'use strict';

import Lore from './lore';
import Collection from './collection';

export default class LoreCollection extends Collection {
  constructor() {
    super(Lore);
  }
}
